export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/rencana-belanja',
    name: 'rencana-belanja',
    component: () => import('@/views/rencana-belanja/Index.vue'),
    meta: {
      pageTitle: 'Rencana Belanja',
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'Rencana Belanja',
          active: true,
        },
      ],
    },
  },
  {
    path: '/satuan-kerja',
    name: 'satuan-kerja',
    component: () => import('@/views/satuan-kerja/Index.vue'),
    meta: {
      pageTitle: 'Satuan Kerja',
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'Satuan Kerja',
          active: true,
        },
      ],
    },
  },
  {
    path: '/satuan-kerja/add',
    name: 'satuan-kerja-add',
    component: () => import('@/views/satuan-kerja/Create.vue'),
    meta: {
      pageTitle: 'Tambah Satuan Kerja',
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'Satuan Kerja',
          to: '/satuan-kerja',
        },
        {
          text: 'Tambah Satuan Kerja',
          active: true,
        },
      ],
    },
  },
  {
    path: '/rencana-belanja',
    name: 'rencana-belanja',
    component: () => import('@/views/rencana-belanja/Index.vue'),
    meta: {
      pageTitle: 'Rencana Belanja',
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'Rencana Belanja',
          active: true,
        },
      ],
    },
  },
  {
    path: '/rencana-belanja/add',
    name: 'rencana-belanja-add',
    component: () => import('@/views/rencana-belanja/Create.vue'),
    meta: {
      pageTitle: 'Rencana Belanja',
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'Rencana Belanja',
          to: '/rencana-belanja',
        },
        {
          text: 'Tambah Rencana Belanja',
          active: true,
        },
      ],
    },
  },
];
